module.exports = __webpack_public_path__ + "static/media/concernTitle.e82432a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/concernTitle.png
// module id = 1293
// module chunks = 0